import { BaseComponent } from 'components/BaseComponent';
import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { compose } from 'redux';
import { createStructuredSelector } from 'reselect';
import styled from 'styled-components';
import { HBox } from '../../../../components/Box';
import { Button } from '../../../../components/Buttons';
import { CircleTimes, Sync } from '../../../../components/Icon';
import { Modal, ModalControls } from '../../../../components/Modal';
import { selectConfig } from '../../../Api/selectors';
import { CompanyLabelById } from '../../../Companies/components/CompanyLabelById';
import { CompanySelection } from '../../../Companies/components/CompanySelection';
import { selectNewInvoiceValue } from '../../../Invoices/selectors';
import { selectNewOrderValue, selectNewVehicleValue } from '../../selectors';
import { CompanySelectionResultTable } from '../../../Companies/components/CompanySelectionResultTable';
import ButtonComponent from '../../../../containers/App/Components/Button/Button';
import styles from './FieldCompany.module.css';
import ModalComponent from '../../../../containers/App/Components/Modal/Modal';

const Container = styled.div`
  width: ${props => (props.formField ? '100%' : '')};
`;

const STATE = {
  active: false,
  selectedCompany: null,
};

/* eslint-disable react/prefer-stateless-function */
class VehicleCreateFieldCompanyComp extends BaseComponent {
  constructor(props) {
    super(props, { ...STATE });
  }

  componentDidMount() {}

  reset() {
    this.setState({ ...STATE });
  }

  applySelection() {
    const result = this.props.selectCompanyObj ? this.state.selectedCompany : this.state.selectedCompany?.id;
    this.props.onChange(result);

    this.reset();
  }

  get userId() {
    if (this.props.tradeInVehicle) {
      return this.props.value;
    }
    if (this.props.order) {
      return this.props.orderValue;
    }
    return this.props.selectedCompanyId ? this.props.selectedCompanyId : this.props.value;
  }

  get companyLabel() {
    let label = `${this.state.selectedCompany?.name ?? ''} ${this.state.selectedCompany?.surname ?? ''}`;

    return label;
  }

  handleDeleteButtonClick() {
    this.setState({ showCompanyContainer: false });
  }

  render() {
    return (
      <Container formField={this.props.formField}>
        <HBox left vCenter>
          <div style={{ width: '100%' }}>
            <div style={{ fontSize: this.props.labelSize ?? '25px' }}>
              <CompanyLabelById company_id={this.userId} key={this.userId} order={this.props.order} fetchName />
            </div>
            {!this.props.tradeInVehicle && (
              <Button style={'ButtonSoftPrimary'} disabled={this.props.disabled} onClick={this.setStateFn({ active: true })}>
                {this.lbl('vehicle.select_customer')}
              </Button>
            )}
          </div>
        </HBox>
        {this.state.active && (
          <ModalComponent
            height="50%"
            size="xl"
            onClose={this.reset.bind(this)}
            title={this.lbl(`vehicle.property.${this.props.title || 'creditor_company'}`)}
          >
            {this.state.selectedCompany ? (
              <div className={styles.buttonGroup}>
                <div className={styles.input}>
                  <CompanySelectionResultTable
                    selected={this.state.selectedCompany && window.innerWidth > 768}
                    companies={[this.state.selectedCompany]}
                    reset={this.reset}
                  />
                </div>
              </div>
            ) : (
              <CompanySelection
                order={this.props.order}
                customerNumberSearch={this.props.customerNumberSearch}
                company={this.props.company}
                onSelect={selectedCompany => {
                  this.setState({ selectedCompany }, this.applySelection);
                }}
              />
            )}
            {/* <ModalControls>
              <Button onClick={this.applySelection.bind(this)} primary disabled={!this.state.selectedCompany}>
                {this.lbl('ok')}
              </Button>
              <Button onClick={this.reset.bind(this)}>{this.lbl('cancel')}</Button>
            </ModalControls> */}
            {window.innerWidth <= 768 && (
              <div className={styles.buttons}>
                <ButtonComponent style="ButtonSoftDelete" onClick={this.reset}>
                  <CircleTimes />
                </ButtonComponent>
              </div>
            )}
          </ModalComponent>
        )}
      </Container>
    );
  }
}

VehicleCreateFieldCompanyComp.propTypes = {
  dispatch: PropTypes.func.isRequired,
};

const mapStateToProps = (state, ownProps) =>
  createStructuredSelector({
    value: selectNewVehicleValue(ownProps.type),
    orderValue: ownProps.invoicePage ? selectNewInvoiceValue(ownProps.type) : selectNewOrderValue(ownProps.type),
    config: selectConfig(),
  });

function mapDispatchToProps(dispatch, ownProps) {
  return {
    dispatch,
  };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export const VehicleCreateFieldCompany = compose(withConnect, withRouter)(VehicleCreateFieldCompanyComp);
